var map = {
	"./consulta-rendimento/consulta-de-lancamento-de-nota-rendimento-gerado/routes.ts": "./src/router/consulta-rendimento/consulta-de-lancamento-de-nota-rendimento-gerado/routes.ts",
	"./consulta-rendimento/consulta-rendimento/routes.ts": "./src/router/consulta-rendimento/consulta-rendimento/routes.ts",
	"./consulta-rendimento/gerar-relatorio-de-rendimento-escolar-geral/routes.ts": "./src/router/consulta-rendimento/gerar-relatorio-de-rendimento-escolar-geral/routes.ts",
	"./dashboard/routes.ts": "./src/router/dashboard/routes.ts",
	"./rendimento/gerar-rendimento/routes.ts": "./src/router/rendimento/gerar-rendimento/routes.ts",
	"./rendimentos/permitir-geracao-do-rendimento/consulta-solicitacao-da-geracao-de-rendimento/routes.ts": "./src/router/rendimentos/permitir-geracao-do-rendimento/consulta-solicitacao-da-geracao-de-rendimento/routes.ts",
	"./rendimentos/permitir-geracao-do-rendimento/gerar-rendimento-ensino-e-disiciplina/routes.ts": "./src/router/rendimentos/permitir-geracao-do-rendimento/gerar-rendimento-ensino-e-disiciplina/routes.ts",
	"./rendimentos/permitir-parametrizar-rendimento/cadastro-de-indicadores-de-rendimento/routes.ts": "./src/router/rendimentos/permitir-parametrizar-rendimento/cadastro-de-indicadores-de-rendimento/routes.ts",
	"./rendimentos/permitir-parametrizar-rendimento/cadastro-de-parametros-de-afericao/routes.ts": "./src/router/rendimentos/permitir-parametrizar-rendimento/cadastro-de-parametros-de-afericao/routes.ts",
	"./txt-de-rendimento/gerar-txt-de-rendimento-por-escola-e-periodo/routes.ts": "./src/router/txt-de-rendimento/gerar-txt-de-rendimento-por-escola-e-periodo/routes.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router sync recursive routes.ts$/";